<template>
  <b-modal
    @show="onShow"
    size="lg"
    scrollable
    no-fade
    no-close-on-esc
    no-close-on-backdrop
    id="modal-upload"
    ref="modal-upload"
    title="Adicionar Arquivos"
  >
    <b-row>
      <b-col lg="12">Pasta: {{ folder.nome }}</b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-form-group label-size="sm" label="Observações" label-for="obs">
          <b-form-textarea id="obs" v-model="uploadData.observacoes" rows="3" no-resize></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="2">
        <b-form-group label-size="sm" label="Versão" label-for="versao">
          <b-form-input type="number" id="versao" v-model="uploadData.versao"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-form-group label-size="sm" label="Ano" label-for="ano">
          <b-form-input type="number" id="ano" v-model="uploadData.ano"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group label-size="sm" label="Mês" label-for="mes">
          <v-select
            append-to-body
            id="mes"
            :options="[{ label: 'Janeiro', id: 1}, { label: 'Fevereiro', id: 2}, 
                        { label: 'Março', id: 3}, { label: 'Abril', id: 4},
                        { label: 'Maio', id: 5}, { label: 'Junho', id: 6},
                        { label: 'Julho', id: 7}, { label: 'Agosto', id: 8},
                        { label: 'Setembro', id: 9}, { label: 'Outubro', id: 10},
                        { label: 'Novembro', id: 11}, { label: 'Dezembro', id: 12}]"
            label="label"
            :reduce="tip => tip.id"
            :clearable="false"
            :searchable="false"
            v-model="uploadData.mes"
          ></v-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <VueFileAgent
          ref="vueFileAgent"
          :theme="'list'"
          :multiple="true"
          :deletable="true"
          :meta="true"
          :maxFiles="14"
          :helpText="'Solte aqui os arquivos ou clique para selecionar'"
          :errorText="{
                    type: 'Invalid file type. Only images or zip Allowed',
                    size: 'Files should not exceed 10MB in size',
                    }"
          @select="filesSelected($event)"
          @delete="fileDeleted($event)"
          @beforedelete="onBeforeDelete($event)"
          @upload="onUploadComplete()"
          v-model="fileRecords"
        ></VueFileAgent>
      </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <b-button
        :disabled="!fileRecordsForUpload.length"
        @click="uploadFiles()"
        size="sm"
        variant="primary"
      >
        <i class="fas fa-check"></i> Fazer Upload
      </b-button>
      <b-button size="sm" @click="() => $bvModal.hide('modal-upload')">Cancelar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { baseApiUrl } from "@/global";

export default {
  name: "ModalUpload",
  props: ["folder"],
  data: function() {
    return {
      uploadData: {
        observacoes: "",
        mes: 0,
        ano: 0,
        versao: 0
      },
      fileRecords: [],
      uploadUrl: `${baseApiUrl}/projetos/${this.folder.projeto_id}/pastas/${this.folder.pasta_id}/arquivos`,
      uploadHeaders: {},
      fileRecordsForUpload: []
    };
  },
  methods: {
    onShow(){
      this.observacoes = ""
      this.mes = new Date().getMonth() + 1
      this.ano = new Date().getFullYear()
      this.versao = 0
      this.fileRecords = []
      this.fileRecordsForUpload = []
    },
    onUploadComplete(){
      this.fileRecordsForUpload = [];
      this.$bvModal.hide("modal-upload");
      this.$emit('uploadComplete', this.folder.pasta_id);
    },
    uploadFiles: function() {
      let _header = {
        Authorization: `Bearer ${this.$store.state.user.access_token}`
      };
      this.uploadUrl = `${baseApiUrl}/projetos/${this.folder.projeto_id}/pastas/${this.folder.pasta_id}/arquivos`;
      try {
        let that = this;
        this.$refs.vueFileAgent.upload(
          this.uploadUrl,
          _header,
          this.fileRecordsForUpload,
          function createFormData(fileData) {
            var formData = new FormData();
            formData.append("action", "upload");
            formData.append("observacoes", that.uploadData.observacoes);
            formData.append("versao", that.uploadData.versao);
            formData.append("ano", that.uploadData.ano);
            formData.append("mes", that.uploadData.mes);
            formData.append("file", fileData.file); // this is important! - the actual file for upload
            return formData; // edit: fixed. Thanks to Chauhan-Nitesh for the comment below
          }
        );
      } catch (e) {
        console.log(e);
      }
    },
    filesSelected: function(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        fileRecord => !fileRecord.error
      );
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
        validFileRecords
      );
    },
    onBeforeDelete: function(fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
      }
    },
    fileDeleted: function(fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      }
    }
  },
  watch: {
    // eslint-disable-next-line
    folder: function(valNew, valOld) {
      this.fileRecordsForUpload = [];
      this.uploadData.mes = new Date().getMonth() + 1;
      this.uploadData.ano = new Date().getFullYear();
    }
  },
  mounted() {
    this.uploadData.mes = new Date().getMonth() + 1;
    this.uploadData.ano = new Date().getFullYear();
  }
};
</script>

<style>
</style>